import { dispensaryService } from '../../../services'
import { serverLocationDetector } from '../../../utils/locationDetector'
import { getDayAndTime } from '../../../utils/Timing'
import { capitalizer, pluralizer } from '../../../helpers/URL'
import dynamic from 'next/dynamic'    
const Business = dynamic(() => import('../../../templates/Business'))
const Layout = dynamic(() => import('../../../components/_App/Layout'))
const Error404 = dynamic(() => import('../../404'))

export default function DispensaryProfileLayout({entity, code, isAppleMobile}) {

  

    function getPosition(string, subString, index) {
        return string.split(subString, index).join(subString).length;
    }

    return (
        <Layout
            isAppleMobile = { isAppleMobile }
            seo={{
                description: entity.about ? `${entity.about.substr(0, getPosition(entity.about, '.', 2)+1)}` : '',
                image: entity.logo ? entity.logo : '/static/icons/favicon.png',
                title: `${entity.name} - ${entity.city.name}, ${entity.city.state.name} - Cannabis ${capitalizer(entity.type)} | Weedzly`,
                url:`https://weedzly.com/${pluralizer(entity.type.toLowerCase())}/${entity.slug}`,
                keywords: [ entity.type.toLowerCase(), entity.city.name.toLowerCase() ]
            }}
        >
            <Business title={`${entity.name} - ${entity.city.name}, ${entity.city.state.name} - Cannabis ${capitalizer(entity.type)} | Weedzly`} entity={entity} />
        </Layout>
    )
    
}

export async function getServerSideProps(context){
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )
            
    try {
      
        await serverLocationDetector(context)
        let dispensarySlug = context.query.slug

        const [ entity ] = await Promise.all([
            dispensaryService.getDetailsPage(dispensarySlug, getDayAndTime(true)), 
        ])

        console.log(entity);
    
        return {
            props: {
                isAppleMobile,
                entity, 
            }
        } 

    } catch({message, code}) {
        if(code && code === 404){
            return {
                notFound: true,
              }
        }
        return {
            props: {
                isAppleMobile,
                success: false,
                code: code,
                contextQuery: context.query,
                message,
            }
        }
    }
    
}
